import { Trans, useLingui } from '@lingui/react/macro'
import { AppLogo } from '@/features/header/app-logo'
import { Link as MultibrandLink } from '@vgw/multibrand-fe-link'
import { getBrandConfig } from '@/config/config'
import { Link, createFileRoute } from '@tanstack/react-router'
import { Content } from '@/layout/content'
import { Layout } from '@/layout/layout'
import { Footer } from '@/features/footer/footer'
import GeoBlockGamePlayMapPin from '@/features/raster-assets/geo-block-game-play-map-pin_444w.png?w=148;296&as=srcset&imagetools'

export const Route = createFileRoute('/geo-block')({
  component: GeoBlock,
})

function GeoBlock() {
  const { name } = getBrandConfig()
  const { t } = useLingui()
  const { helpCenterUrl } = getBrandConfig()

  return (
    <Layout>
      <Content>
        <main className="flex w-full flex-1 flex-col bg-page-small-background bg-contain bg-top bg-no-repeat 2xl:bg-cover">
          <div className="flex flex-1 flex-col items-center justify-center bg-page-gradient text-center">
            <div className="flex grow flex-col">
              <div className="flex flex-col items-center px-3 pt-10">
                <MultibrandLink asChild>
                  <Link
                    to="/"
                    title={t`Go to VGW ${name} Homepage`}
                    aria-label={t`Go to VGW ${name} Homepage`}
                  >
                    <AppLogo className="h-[70px] w-[39px]" />
                  </Link>
                </MultibrandLink>
              </div>

              <div className="flex grow flex-col items-center justify-center gap-4 px-8 py-10">
                <img
                  srcSet={GeoBlockGamePlayMapPin}
                  width={148}
                  height={148}
                  alt=""
                  aria-hidden
                />
                <div className="flex flex-col gap-3 text-center">
                  <h1 className="text-2xl font-bold">
                    <Trans>Thank you for your interest!</Trans>
                  </h1>
                  <p className="text-lg font-light">
                    <Trans>
                      Unfortunately, {name} is not available in your region.
                      <br />
                      If you believe you should have access, please visit{' '}
                      <MultibrandLink
                        className="underline"
                        href={helpCenterUrl}
                      >
                        Help Center
                      </MultibrandLink>
                      .
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </Content>
      <Footer suppressAmoe />
    </Layout>
  )
}
